<div
  cdkDropList
  [cdkDropListData]="listData$ | async"
  [cdkDropListDisabled]="disabled"
  [cdkDropListSortingDisabled]="isGrouped()"
  [cdkDropListEnterPredicate]="enterIfEnabledPredicateFn"
  [cdkDropListConnectedTo]="treatmentGroupDragDrop.lists$ | async"
  (cdkDropListDropped)="treatmentGroupDragDrop.drop($event)"
>
  <ng-content select="[scopeListHeader]" />

  <div class="pt-2">
    <ng-container *ngIf="allTreatments$ | async as allTreatments">
      <div
        *ngIf="!allTreatments.length"
        class="is-empty-placeholder mat-caption"
      >
        No Treatments
      </div>

      <ng-container *ngIf="treatmentGroups$ | async as treatmentGroups">
        <div
          *ngIf="treatmentGroups.length"
          class="treatment-group-container flex flex-col gap-2"
        >
          <ng-container
            *ngFor="
              let treatmentGroup of treatmentGroups;
              trackBy: trackByTreatmentGroup
            "
          >
            <pr-treatment-scope-grouped
              class="flex-1"
              cdkDrag
              cdkDragPreviewClass="drag-preview-transparent"
              [cdkDragData]="treatmentGroup"
              [cdkDragDisabled]="disabled"
              [treatment]="treatmentGroup"
              [selectedSurfaces]="selectedSurfaces$ | async"
              [expanded]="expanded"
              [disabled]="disabled"
              [compact]="compact"
              [plan]="plan$ | async"
              [step]="step$ | async"
              [connectedLists]="treatmentGroupDragDrop.lists$ | async"
              [appointment]="appointment"
              (treatmentChanged)="updateTreatment(allTreatments, $event)"
              (treatmentDeleted)="deleteTreatments($event)"
              (updateChartable)="updateChartable.emit($event)"
              (categoryChanged)="categoryChanged.emit($event)"
            >
              <mat-icon
                cdkDragHandle
                class="drag-handle"
                [ngClass]="{ disabled: disabled }"
              >
                drag_handle
              </mat-icon>
            </pr-treatment-scope-grouped>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="treatments$ | async as treatments">
        <div class="flex flex-col">
          <ng-container
            *ngFor="let treatment of treatments; trackBy: trackByTreatment"
          >
            <pr-treatment-scope
              class="treatment-card flex-1"
              cdkDrag
              cdkDragPreviewClass="drag-preview-transparent"
              [cdkDragData]="treatment"
              [cdkDragDisabled]="disabled"
              [treatment]="treatment"
              [selectedSurfaces]="selectedSurfaces$ | async"
              [step]="step$ | async"
              [plan]="plan$ | async"
              [expanded]="expanded"
              [disabled]="disabled"
              [compact]="compact"
              [appointment]="appointment"
              (treatmentChanged)="updateTreatment(allTreatments, $event)"
              (treatmentDeleted)="deleteTreatments($event)"
              (updateChartable)="updateChartable.emit($event)"
              (categoryChanged)="categoryChanged.emit($event)"
            >
              <mat-icon
                cdkDragHandle
                class="drag-handle"
                [ngClass]="{ disabled: disabled }"
              >
                drag_handle
              </mat-icon>
            </pr-treatment-scope>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-content select="[scopeListFooter]" />
